import * as types from "../types";

export const loginRequest = ({loginReq}) => ({
    type: types.LOGIN_REQUEST,
    payload:{
        loginReq
    }
})

export const loginSuccess = ({loginResult}) => ({
    type: types.LOGIN_SUCCESS,
    payload:{
        loginResult
    }
})

export const loginFailure = ({error}) => ({
    type: types.LOGIN_FAILURE,
    payload:{
        error: error.message
    }
})

